import { BreadcrumbItem } from "common/components/breadcrumb/Breadcrumb";
import { urls } from "common/urls";

import gql from "graphql-tag";

export const contentBreadcrumbFragment = gql`
  fragment ContentBreadcrumbFragment on Content {
    id
    title
    status
    context {
      id
      title
    }
  }
`;

export const homeBreadcrumb: BreadcrumbItem[] = [
  { name: "Hjem", path: urls.frontPage },
];

export const administrationBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Administrasjon",
    path: urls.admin,
  },
];

export const libraryBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Biblioteket",
    path: urls.library,
  },
];

export const mySyllabusBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Mitt pensum",
    path: urls.myStudies,
  },
];

export const feedbackBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Tilbakemeldinger",
    path: urls.feedback,
  },
];

export const teacherFeedbackBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Tilbakemeldinger",
    path: urls.teacherFeedback,
  },
];

export const questionsBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Spørsmål",
    path: urls.questions,
  },
];

export const teacherQuestionsBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Innboks",
    path: urls.teacherQuestions,
  },
];

export const profileBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Profil",
    path: urls.profile,
  },
];

export const termsOfUseBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Brukervilkår",
    path: urls.termsOfUse,
  },
];

export const simulationBreadcrumb: BreadcrumbItem[] = [
  ...homeBreadcrumb,
  {
    name: "Simuleringsbasert læring",
    path: urls.simulation,
  },
];
